export const MODEL_TYPE = ['all', 'delivery', 'invoice'] as const;

export const AI_MODEL_PLATFORM = ['all', 'di', 'ai_foundry'] as const;
